import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import styled from 'styled-components';
import { spacing } from '../../style/theme';
import SiteLinksListContainer from './SiteLinksListContainer';
var SiteLinksLayout = styled.div.withConfig({
  displayName: "SiteLinksSection__SiteLinksLayout",
  componentId: "sc-1knzoii-0"
})(["display:flex;@media only screen and (max-width:", "px){flex-wrap:wrap;}"], spacing.collapseMenuWidth);
var SiteLinksLayoutCol = styled.div.withConfig({
  displayName: "SiteLinksSection__SiteLinksLayoutCol",
  componentId: "sc-1knzoii-1"
})(["flex:1 0px;margin-right:", "px;@media only screen and (max-width:", "px){flex:1 0 50%;width:50%;margin-bottom:", "px;}"], spacing.base, spacing.collapseMenuWidth, spacing.base);
var SiteLinksList = styled.ul.withConfig({
  displayName: "SiteLinksSection__SiteLinksList",
  componentId: "sc-1knzoii-2"
})(["list-style-type:none;margin:0;"]);
var SiteLinksItem = styled.li.withConfig({
  displayName: "SiteLinksSection__SiteLinksItem",
  componentId: "sc-1knzoii-3"
})(["margin-bottom:0;"]);

var getLinkStyled = function getLinkStyled(Link) {
  return styled(Link).withConfig({
    displayName: "SiteLinksSection",
    componentId: "sc-1knzoii-4"
  })(["text-decoration:none;&:hover{text-decoration:underline;}"]);
};

var SiteLinksSection = function SiteLinksSection(_ref) {
  var links = _ref.links,
      Link = _ref.Link;
  var LinkStyled = getLinkStyled(Link);
  return React.createElement(SiteLinksLayout, null, links.map(function (section) {
    return React.createElement(SiteLinksLayoutCol, {
      key: section.name
    }, React.createElement(SiteLinksListContainer, {
      title: section.name
    }, React.createElement(SiteLinksList, null, section.links.map(function (link) {
      return React.createElement(LinkStyled, _extends({
        key: link.name,
        href: link.href
      }, link.props), React.createElement(SiteLinksItem, null, link.name));
    }))));
  }));
};

export default SiteLinksSection;